/** The dashboard's theme (Layout's toggle sets `data-theme="dark"` on <html>), read where a picture is asked in it. */
import { useEffect, useState } from "react";

export function isDarkTheme(): boolean {
  return typeof document !== "undefined" && document.documentElement.dataset.theme === "dark";
}

/** True while the dashboard is dark; follows the toggle. */
export function useDarkTheme(): boolean {
  const [dark, setDark] = useState(isDarkTheme);
  useEffect(() => {
    const watch = new MutationObserver(() => setDark(isDarkTheme()));
    watch.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => watch.disconnect();
  }, []);
  return dark;
}

/** A Sketch's drawn preview (`…/site/image`) in the dashboard's theme: its plain ground dark on a dark page. */
export function sitePictureUrl(url: string, opts: { sketch: boolean; dark: boolean; panels?: boolean }): string {
  const q = new URLSearchParams();
  if (opts.sketch && opts.panels) q.set("panels", "1");
  if (opts.sketch && opts.dark) q.set("theme", "dark");
  const s = q.toString();
  return s ? `${url}${url.includes("?") ? "&" : "?"}${s}` : url;
}
